<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="350">
      <v-card>
        <v-card-title
          class="headline body-1 blue darken-1 lighten-1 white--text font-weight-thin"
          primary-title
        >
          <v-icon class="white--text mr-2">mdi-view-list</v-icon>Adicionar
          Categoria
        </v-card-title>
        <v-card-text class="pa-8">
          <v-form novalidate ref="form" v-model="valid" lazy-validation>
            <v-select
              v-model="productName"
              :rules="nameRules"
              label="Serviços"
              required
              item-value="id"
              item-text="categoryServiceName"
              :items="getCategoryInCache"
              filled
            ></v-select>
            <v-select
              v-model="productName"
              :rules="nameRules"
              label="Categoria de produto"
              required
              item-value="id"
              item-text="categoryServiceName"
              :items="getCategoryInCache"
              filled
            ></v-select>
            <v-card-actions>
              <v-btn
                color="deep-purple lighten-2"
                text
                block
                @click="
                  {
                  }
                "
                :disabled="!valid"
                :loading="loading"
              >
                Adicionar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import eventBus from "../../../../main";
import { mapHelperEnterprise } from "../../../../store/helperEnterprise";

export default {
  name: "OpenAddProductCategory",
  data: () => ({
    newPassword: "",
    repeatPassword: "",
    dialog: false,
    valid: true,
    value: true,
    loading: false,
    pwdRules: [
      v => !!v || "Palavra-passe é requerida",
      v => (v && v.length >= 6) || "Deve ter no mínimo 6 caracter",
      v =>
        /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*\W+)(?=^.{6,15}$).*$/.test(v) ||
        "Deve ter minúsculas, maísculas e caracter especial"
    ]
  }),
  created() {
    const self = this;
    eventBus.$on("openAddProductCategory", function(value) {
      self.dialog = value;
      // self.newPassword = "";
      // self.repeatPassword = "";
    });
  },
  computed: {
    ...mapHelperEnterprise
  }
};
</script>

<style scoped>
.m-center {
  text-align: center;
}
</style>
